import DashboardPage from "../../vue/components/pages/DashboardPage.vue";
import ProfilePage from "../../vue/components/pages/ProfilePage.vue";
import ProjectListPage from "../../vue/components/pages/ProjectListPage.vue";
import ProjectPage from "../../vue/components/pages/ProjectPage.vue";
import ProposalPage from "../../vue/components/pages/ProposalPage.vue";
import AssistantListPage from "../../vue/components/pages/AssistantListPage.vue";
import AssistantPage from "../../vue/components/pages/AssistantPage.vue";

import SignupPage from "../../vue/components/pages/SignupPage.vue";
import NotFoundPage from "../../vue/components/pages/NotFoundPage.vue";
import LoginSuccessPage from "../../vue/components/pages/LoginSuccessPage.vue";
import LoginErrorPage from "../../vue/components/pages/LoginErrorPage.vue";

import Config from "../../../resources/config.js";

const routeMap = [
    { pt: '', en: '' },
    { pt: '/perfil', en: '/profile' },
    { pt: '/projetos', en: '/projects' },
    { pt: '/encontre-talentos', en: '/find-talent' },
    { pt: '/assistente/:assistantId', en: '/assistant/:assistantId' },
    { pt: '/projeto/:projectId', en: '/project/:projectId' },
    { pt: '/proposta/:projectId/:assistantId', en: '/proposal/:projectId/:assistantId' },
    { pt: '/login-feito', en: '/login-done' },
    { pt: '/erro-login', en: '/login-error' },
    { pt: '/cadastro', en: '/signup' },
    { pt: '/:catchAll(.*)', en: '/:catchAll(.*)' }
]

function resolveComponentForPath(path) {
    switch (path) {
        case '':
            return DashboardPage
        case '/perfil':
            return ProfilePage
        case '/projetos':
            return ProjectListPage
        case '/encontre-talentos':
            return AssistantListPage
        case '/assistente/:assistantId':
            return AssistantPage
        case '/projeto/:projectId':
            return ProjectPage
        case '/proposta/:projectId/:assistantId':
            return ProposalPage
        case '/login-feito':
            return LoginSuccessPage
        case '/erro-login':
            return LoginErrorPage
        case '/cadastro':
            return SignupPage
        default:
            return NotFoundPage
    }
}

const routes = routeMap.map(({ pt }) => ({
    path: pt,
    component: resolveComponentForPath(pt)
}))

const enRoutes = routeMap.filter(({ en }) => !en.includes(':catchAll')).map(({ en }) => ({
    path: en,
    beforeEnter: (to) => {
        const baseUrl = Config.englishWebapp.replace(/\/$/, '');
        const finalPath = to.path;
        const queryString = new URLSearchParams(to.query).toString();
        const finalUrl = `${baseUrl}${finalPath}${queryString ? '?' + queryString : ''}`

        window.location.href = finalUrl
    }
}))


Config.routeMap = routeMap;
export default [...routes, ...enRoutes];